/* * @Author: ligai  */
<template>
  <div class="header-layout" ref="shoppingNumber">
    <div class="logo-search-box right-search">
      <div class="mall-logo-box">
        <div class="mall-logo">
          <a :href="logoLink" target="_self" class="logo-link">
            <img class="logo" :src="logoUrl | imgHost" alt="">
          </a>
          <span class="line"></span>
          <el-popover
            v-if="isAuth && supplierId > 0"
            width="246"
            trigger="hover"
            :visible-arrow="false"
            placement="bottom-start"
            popper-class="supplier-info-popover"
            @after-enter="showAfter"
          >
            <div class="content">
              <div v-if="supplyEvalInfo.supportEval && supplyEvalInfo.scoreTotal" :class="[retracted && 'show-one-line']">
                <ul id="supplier-eval">
                  <li
                    v-for="item in supplyEvalInfo.subEvalVOS"
                    :key="item.name"
                    :style="{width: item.name.length > 5 ? '100%' : '33%'}"
                    class="points-item"
                  >
                    <div class="score-name">{{item.name}}</div>
                    <div class="score-detail">
                      <span v-if="item.score"> {{item.score.toFixed(2)}}</span>
                      <span v-else>{{pageText.no}}</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="operation-wrap" v-if="showOperation">
                <Buttons type="link" v-if="retracted" @click="() => retracted = !retracted">{{pageText.more}}<i class="el-icon-arrow-down"></i></Buttons>
                <Buttons type="link" v-else @click="() => retracted = !retracted">{{pageText.stow}}<i class="el-icon-arrow-up"></i></Buttons>
              </div>
              <ul class="supplier-address-phone">
                <li>
                  <span class="name">{{pageText.aftersalesTelephone}}</span>
                  <span class="info">{{supplyInfo.afterSalePhone || '-'}}</span>
                </li>
                <li>
                  <span class="name">{{pageText.businessAddress}}</span>
                  <span class="info">{{supplyInfo.address || '-'}}</span>
                </li>
              </ul>
            </div>
            <span class="mall-key-words supplier-info" slot="reference">
              <router-link class="supplier-name" :to="{name:'supplier-shop', query:{supplierId: supplierId, mallSkuId: this.mallSkuId}}" target="_self"> {{supplyInfo.name}} </router-link>
              <i class="iconfont icon-shangcheng-xialajiantou triangle"></i>
              <span class="score" v-if="supplyEvalInfo.supportEval">
                <span>{{pageText.scoreTotal}}</span>
                <span v-if="supplyEvalInfo.scoreTotal">{{supplyEvalInfo.scoreTotal.toFixed(2)}}</span>
                <span v-else>{{pageText.no}}</span>
              </span>
            </span>
          </el-popover>
          <span :class="{'mall-key-words': true, 'mall-img': mallNameType === 1}" v-else>
            <span v-if="mallNameType === 0">{{mallName}}</span>
            <img :src="mallName | imgHost" alt="" class="mall-name-img" v-else-if="mallNameType === 1">
          </span>
        </div>
      </div>
      <SearchBox class="header-search-box" :isGetCity="isGetCity" :pageInfo="pageInfo" :supplierId="supplierId"></SearchBox>
    </div>
  </div>

</template>
<script>
import { mixin } from './mixins.js'
import { Buttons } from 'fe-coms'
export default {
  mixins: [mixin],
  components: {
    Buttons
  },
  data () {
    return {
      // 是否展示操作区
      showOperation: false,
      // 按钮是否是收起状态
      retracted: true
    }
  },
  watch: {
    // 监听评分变化
    supplyEvalInfo: {
      handler: function (newVal, oldVal) {
        this.showOperation = false
        this.retracted = true
        if (newVal?.supportEval && Array.isArray(newVal.subEvalVOS)) {
          // 评分大于3个
          if (newVal.subEvalVOS.length > 3) {
            this.showOperation = true
          } else {
            this.showOperation = newVal.subEvalVOS.some(i => i.name.length > 5)
          }
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
.header-layout {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  .logo-search-box {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    padding: 23px 0 21px 0;
  }
  .right-search {
    .header-search-box {
      justify-content: flex-end;
      display: flex;
      flex: 1;
    }
  }
  .mall-logo-box {
    margin-right: 30px;
    .mall-logo{
      display: flex;
      display: -webkit-flex;
      flex-wrap: nowrap;
      align-items: center;
      max-width: 604px;
      max-height: 48px;
      .logo{
        max-height: 48px;
        max-width: 130px;
        width: 100%;
        vertical-align: middle;
        cursor: pointer;
      }
      .line{
        background-color: #E2E7F4;
        margin: 0 10px;
        display: inline-block;
        height: 13px;
        width: 2px;
      }
      .mall-key-words{
        height: 100%;
        font-weight: 600;
        font-size: 18px;
        max-width: 160px;
        .mall-name-img{
          max-height: 30px;
          max-width: 160px;
          vertical-align: middle;
        }
        &.mall-img{
          max-width: 160px;
        }
        &.supplier-info{
          .supplier-name{
            max-width: 160px;
            display: inline-block;
            line-height: 22px;
            vertical-align: text-top;
            font-size: 18px;
            color: #242F57;
            font-weight: 500;
            max-height: 40px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .triangle{
            display: inline-block;
            transform: scale(0.5);
            color: #97A0C3;
            margin-right: 8px;
            vertical-align: text-top;
          }
          .score{
            font-size: 12px;
            background-color: #F3F4FA;
            padding: 4px 10px;
            border-radius: 4px;
            line-height: 18px;
            color: #242F57;
            display: inline-block;
            vertical-align: middle;
            &.no-score{
              background-color: #F3F4FA;
            }
          }
        }
      }
    }
  }
}

.supplier-info-popover{
  .content{
    font-size: 12px;
    color: #666666;
    line-height: 20px;
    padding: 8px;

    .show-one-line {
      height: 50px;
      overflow: hidden;
    }
    .points-item{
      display: inline-block;
      font-size: 12px;
      padding-bottom: 12px;
      div {
        text-align: left;
      }
      .score-name {
        width: 100%;
        color: #70727A;
        line-height: 18px;
      }
      .score-detail {
        width: 100%;
        color: #EA6301;
        line-height: 20px;
        font-weight: 500;
        font-size: 14px;
        color: #242F57;
      }
    }
    .operation-wrap {
      width: 100%;
      font-size: 14px;
      line-height: 14px;
      color: #3072F3;
      padding-bottom: 12px;
      cursor: pointer;
      i {
        margin-left: 4px;
      }
    }
    .supplier-address-phone{
      border-top: 1px dashed #EEEEEE;
      padding-top: 12px;
      .name{
        display: inline-block;
        vertical-align: top;
        line-height: 18px;
        font-size: 12px;
        width: 54px;
      }
      .info{
        display: inline-block;
        vertical-align: top;
        line-height: 18px;
        font-size: 12px;
        width: 172px;
        font-weight: 500;
      }
    }
  }
}
</style>
<style lang="scss">
.supplier-info-popover{
  &.el-popper[x-placement^=bottom]{
    margin-top: 4px;
  }
}
